import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { useFormikContext } from 'formik'
import { Header } from 'SRC/modules/ads/shared/components/FormElements/Header'
import { setActiveTab } from 'SRC/modules/ads/add/actions'
import { getActiveTab } from 'SRC/modules/ads/add/selectors'

import { AuthFormPhone } from '../AuthFormPhone'
import { NewUser } from '../NewUser'

const tabs = [
  {id: 'register', title: 'Novi korisnik'}
]

const Container = ({
  activeTab,
  setActiveTab
}) => {
  const formik = useFormikContext()
  const { t } = useTranslation('common')

  React.useEffect(() => {
    formik.validateForm()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  return (
    <React.Fragment>
      <Header title={t('Kontakt podaci')} key='auth-or-register-header' />
      <div className='kontakt-podaci uspesno-poslato' key='auth-or-register-tabs'>
        <div className='kontakt-podaci-header'>
          <a
            href='javascript:void(0)'
            key={'register'}
          >
            {t('Novi korisnik')}
          </a>
        </div>

        <NewUser isActive={activeTab === 'register'} />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  activeTab: getActiveTab(state)
})

Container.displayName = 'AuthAndRegisterForm'

Container.propTypes = {
  setActiveTab: PropTypes.func.isRequired,
  activeTab: PropTypes.oneOf(['register', 'auth']).isRequired
}

export default connect(mapStateToProps, { setActiveTab })(Container)
